"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const office_ui_fabric_react_1 = require("office-ui-fabric-react");
const styles_1 = require("./styles");
const ImportLoading = () => {
    return (react_1.default.createElement(office_ui_fabric_react_1.Stack, { horizontalAlign: "center", verticalAlign: "center", verticalFill: true, tokens: { childrenGap: 30 }, styles: { root: { height: '400px' } } },
        react_1.default.createElement(office_ui_fabric_react_1.Spinner, { label: "Importing...", size: office_ui_fabric_react_1.SpinnerSize.large }),
        react_1.default.createElement(office_ui_fabric_react_1.Text, { block: true, styles: styles_1.styles.loadingTextNote }, "The import may take a few minutes.")));
};
exports.default = ImportLoading;
